/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */

export interface TextProps {
    body?: string | null;
    className?: string | null;
}

function Text({ body = null, className = null }: TextProps) {
    return (
        <div className={className ?? undefined} dangerouslySetInnerHTML={{ __html: body ?? '' }} />
    );
}

export default Text;
